"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderCardHeader_unstable", {
    enumerable: true,
    get: function() {
        return renderCardHeader_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const renderCardHeader_unstable = (state)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(state.root, {
        children: [
            state.image && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.image, {}),
            state.header && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.header, {}),
            state.description && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.description, {}),
            state.action && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.action, {})
        ]
    });
};
